<!--  接单流程 OrderProcess -->
<!-- 开普勒视频 -->
<template>
  <div class="OrderProcess">
    <div class="title_index">
      <div class="name">接单流程</div>
      <div class="detailed">
        <div>线上接单，知识与收益双增长</div>
      </div>
    </div>
    <div class="OrderProcess_list">
      <div v-for="(item, index) in setDataName" :key="index" id="OrderProcess_conten">
        <div id="OrderProcess_list_item" :class="{ active: changeListindex == index }">
          <div class="OrderProcess_list_div">
            <div class="OrderProcess_sum">{{ index + 1 }}</div>
            <div class="OrderProcess_img">
              <img width="32" height="32" :src="require('../../assets/image/indexqiye/' + item.img + '.png')" alt="">
            </div>
            <div class="OrderProcess_text">{{ item.name }}</div>
          </div>
        </div>
        <div v-if="index < 6" class="OrderProcess_arrow"></div>
      </div>

    <!-- <div class="OrderProcess_jq">

            </div> -->
    </div>


  </div>
</template>

<script>
// import { showNumber, packageListHomepage } from "@/api/projectSquare/xmgc";
export default {
  name: 'OrderProcess',
  data() {
    return {
      setDataName: [
        { id: 0, img: '3-1', name: '注册会员' },
        { id: 1, img: '3-2', name: '认证为工程师' },
        { id: 2, img: '3-3', name: '实名认证' },
        { id: 3, img: '3-4', name: '报名接单' },
        { id: 4, img: '3-5', name: '确认合作' },
        { id: 5, img: '3-6', name: '完成任务' },
        { id: 6, img: '3-7', name: '验收收款' },
      ],
      changeListindex: 0, //

    };
  },
  created() {
    this.$nextTick(() => {
      setInterval(() => {
        if (this.changeListindex < 6) {
          this.changeListindex = this.changeListindex + 1;
        } else {
          this.changeListindex = 0;
        }
      }, 1000);


    });
  },
  methods: {

  },
};
</script>

<style scoped>
.OrderProcess {
  width: 100%;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  margin-top: 180px;
  padding-bottom: 130px;
}

.title_index {
  padding: 120px 0 72px 0;
}

.title_index .name {
  font-size: 72px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
  line-height: 84px;
}

.title_index .detailed {
  font-size: 32px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}


.OrderProcess_list {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

#OrderProcess_list_item {
  width: 180px;
  height: 200px;
  background: url(../../assets/image/indexqiye/2-1.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  position: relative;
  transition: 1s;
}

#OrderProcess_list_item:hover {
  transform: scale(1.2);
  z-index: 3;
}

.active {
  transform: scale(1.2);
  z-index: 3;
}

.OrderProcess_list_div {
  width: 116px;
  margin: 0 auto;
}

.OrderProcess_sum {
  font-size: 24px;
  font-weight: 800;
  color: #FFFFFF;
  line-height: 28px;
  padding-top: 14px;
}

.OrderProcess_text {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  line-height: 20px;
}

.OrderProcess_img {
  padding-top: 20px;
}

.OrderProcess_jx {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  line-height: 14px;
}

.OrderProcess_jq {
  width: 1080px;
  display: flex;
  position: absolute;
  left: 21.5%;
  top: 37%;
}

#OrderProcess_conten {
  position: relative;
}

.OrderProcess_arrow {
  width: 29.74px;
  height: 23.83px;
  background: url(../../assets/image/indexqiye/jt.png) no-repeat;
  background-size: 100% 100%;
  transform: translate(0%, -50%);
  position: absolute;
  right: -8%;
  top: 36%;
}
</style>



// WEBPACK FOOTER //
// src/components/Lunbot/OrderProcess.vue